import { Box } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { MRT_RowData, MRT_TableInstance } from 'material-react-table';
import UtmsGlobalFilterTextField from '@shared/components/ui/UtmsGlobalFilterTextField';
import ToggleMoreFiltersButton from '@shared/components/others/ToggleMoreFiltersButton/ToggleMoreFiltersButton';

interface PcapFilesFiltersProps {
    globalFilter: string;
    setGlobalFilter: Dispatch<SetStateAction<string>>;
    table: MRT_TableInstance<MRT_RowData>;
}

const PcapFilesFilters: FC<PcapFilesFiltersProps> = ({ globalFilter, setGlobalFilter, table }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', pt: 2, pb: 2 }}>
            <UtmsGlobalFilterTextField
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                label={t('name_or_id')}
                table={table}
            />

            <Box>
                <ToggleMoreFiltersButton table={table} />
            </Box>
        </Box>
    );
};

export default PcapFilesFilters;
